import { cn } from '@/lib/utils'
import { Separator } from '@/components/ui/separator'

interface SectionHeadingProps {
  tagline?: string
  title: string
  subtitle?: string
  centered?: boolean
  className?: string
}

export function SectionHeading({
  tagline,
  title,
  subtitle,
  centered = true,
  className,
}: SectionHeadingProps) {
  return (
    <div className={cn('mb-12', centered && 'text-center', className)}>
      {tagline && (
        <p className="mb-2 text-sm font-semibold uppercase tracking-widest text-terracotta">
          {tagline}
        </p>
      )}
      <h2 className="font-heading text-3xl font-bold text-wood-dark md:text-4xl lg:text-5xl">
        {title}
      </h2>
      {subtitle && <p className="mx-auto mt-4 max-w-2xl text-lg text-stone">{subtitle}</p>}
      <Separator
        className={cn('mt-6 h-1 w-20 rounded-full bg-gold', centered && 'mx-auto')}
      />
    </div>
  )
}
